import Template from "../../components/Template";
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { formatDateWithoutHour } from "../../utils/date";

const Alertas = () => {
    const navigate = useNavigate();
    const [alerts, setAlerts] = useState([]);

    // Buscar os alertas ao montar o componente
    useEffect(() => {
        const fetchAlerts = async () => {
            try {
                // Certifique-se de que o endpoint esteja correto e retorne { alerts: [...] }
                const response = await api.get('/alertas');
                setAlerts(response.data.alerts);
            } catch (error) {
                console.error("Erro ao buscar alertas:", error);
            }
        };

        fetchAlerts();
    }, []);

    // Função para fechar (remover) o card
    const handleClose = (id) => {
        setAlerts((prevAlerts) => prevAlerts.filter((alert) => alert.id !== id));
    };

    // Função para formatar a data para o formato dd/mm/aaaa
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return date.toLocaleDateString("pt-BR");
    };

    return (
        <Template>
            <div className="h-auto w-full p-4 md:p-8 flex flex-col gap-6">
                {/* Cabeçalho */}
                <div className="flex flex-wrap justify-between items-center gap-4">
                    <div className="text-stone-800 text-xl md:text-2xl font-medium font-['Inter']">
                        Alertas
                    </div>
                </div>

                {/* Container dos Cards (lado a lado com quebra de linha conforme o espaço) */}
                <div className="flex flex-wrap gap-4">
                    {alerts.length > 0 ? (
                        alerts.map((alert) => (
                            <div
                                key={alert.id}
                                className="relative bg-white shadow rounded p-4 flex items-center gap-4 w-full sm:w-1/2 md:w-1/3"
                            >
                                {/* Ícone de alerta à esquerda */}
                                <div className="flex-shrink-0">
                                    {alert.isUrgent ? (
                                        <img className="w-8 h-8" src="images/icon/alert-triangle-red.png" />
                                    ) : (
                                        <img className="w-8 h-8" src="images/icon/alert-triangle-yellow.png" />
                                    )}
                                </div>

                                {/* Conteúdo do Card */}
                                <div className="flex-1">
                                    <div className="text-stone-600 text-base font-medium font-['Inter']">
                                        Vencimento {alert.isUrgent ? `Expirando` : 'Próximo'}: {alert.title}
                                    </div>
                                    <div className="flex flex-col gap-2 mt-2">
                                        <div className="flex items-center gap-2">
                                            <div className="text-stone-600 text-[13px] font-light font-['Inter']">
                                                Tipo:
                                            </div>
                                            <div className="text-stone-600 text-[13px] font-light font-['Inter']">
                                                {alert.type}
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <div className="text-stone-600 text-[13px] font-light font-['Inter']">
                                                Vencimento em:
                                            </div>
                                            <div className="text-stone-600 text-[13px] font-light font-['Inter']">
                                                {formatDateWithoutHour(alert.expirationDate)}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Botão para fechar o card */}
                                <button
                                    className="absolute top-2 right-2 text-stone-600 hover:text-stone-800"
                                    onClick={() => handleClose(alert.id)}
                                >
                                    X
                                </button>
                            </div>
                        ))
                    ) : (
                        <div className="text-stone-600 text-base font-light font-['Inter']">
                            Nenhum alerta no momento.
                        </div>
                    )}
                </div>
            </div>
        </Template>
    );
};

export default Alertas;
